import { isAddress, zeroAddress } from 'viem'
import { useContractReads } from 'wagmi'
import { DEXES } from 'views/TradingCompetitionV3/config'
import { competitionV4Abi } from './abi'
import { V4_ADDRESS, V4_CHAIN_ID } from './config'
import { CURRENCY_INDEX, Currency } from './fee'

const on = (functionName: string, args?: any[]) => ({ address: V4_ADDRESS || undefined, abi: competitionV4Abi, functionName, args, chainId: V4_CHAIN_ID }) as any // V4_CHAIN_ID = 97 during the testnet trial

/** Fees per currency, switches and the referrer's next rate, read straight from the V4 contract. */
export function useV4Settings(account?: string, referrer?: string, currency: Currency = 'bnb') {
  const ref = referrer && isAddress(referrer) ? referrer : zeroAddress
  const { data, isLoading } = useContractReads({
    contracts: [
      on('feeConfig', [0]), on('feeConfig', [1]), on('paused'), on('owner'), on('currentValidatorConfigId'),
      on('competitionRulesHash', [0n]), on('competitionRulesHash', [1n]), on('getNextReferralRate', [ref, CURRENCY_INDEX[currency]]), on('referrerRegistered', [ref]),
      ...DEXES.map((d) => on('supportedFactories', [d.factory])),
      on('referrerRegistered', [account && isAddress(account) ? account : zeroAddress]),
    ],
    enabled: Boolean(V4_ADDRESS),
    staleTime: 30_000,
    watch: false,
  }) as any
  const val = (i: number) => (data?.[i]?.status === 'success' ? data[i].result : undefined)
  const fee = (i: number) => {
    const r = val(i) as readonly [bigint, bigint, boolean] | undefined
    return r ? { cost: r[0], costWithReferral: r[1], enabled: r[2] } : undefined
  }
  const owner = val(3) as string | undefined
  return {
    loading: isLoading,
    fees: { bnb: fee(0), cbon: fee(1) } as Record<Currency, { cost: bigint; costWithReferral: bigint; enabled: boolean } | undefined>,
    paused: val(2) as boolean | undefined,
    owner,
    isOwner: Boolean(account && owner && account.toLowerCase() === owner.toLowerCase()),
    configId: val(4) as bigint | undefined,
    rulesHash: [val(5), val(6)] as (`0x${string}` | undefined)[],
    nextReferralRate: val(7) as bigint | undefined,
    // audit F-02: a commission goes only to a registered wallet (one free tx, or any past creation)
    referrerRegistered: val(8) as boolean | undefined,
    factoryEnabled: DEXES.map((d, i) => ({ ...d, enabled: val(9 + i) as boolean | undefined })),
    selfRegistered: val(9 + DEXES.length) as boolean | undefined,
  }
}
